const contentData = [
  {
    title: "Launch campaigns",
    link: "/upload/1",
    description:
      "Set up brand and product campaigns in one place and get them in front of your audience."
  },
  {
    title: "Scan & earn",
    link: "/upload/2",
    description:
      "Fans scan QR codes to unlock discounts and earn ranking points—every redemption fuels engagement."
  },
  {
    title: "Recognize your fans",
    link: "/upload/3",
    description:
      "Reward your most active and loyal followers while you gain clear insights into your audience and campaign performance."
  }
];

export default contentData;
